import { code } from "@spscommerce/utils";

export const SpsFocusedTaskExamples = {
  basic: {
    examples: {
      basic: {
        template: code`
          <sps-focused-task #focusedTask (close)="onFocusedTaskClosed()">
            <div style="width: 50%; margin: auto">
              <h2>Focused Task</h2>
              <sps-card>
                <i>pretend there's a form here</i>
              </sps-card>
            </div>
            <sps-focused-task-actions>
              <sps-button kind="confirm" (click)="focusedTask.close()">
                Submit
              </sps-button>
            </sps-focused-task-actions>
          </sps-focused-task>
          <sps-button (click)="focusedTask.open()"
            aria-label="Open focused task">
            Open focused task
          </sps-button>
        `,
        class: code`
          class DemoComponent {
            onFocusedTaskClosed() {
              console.log("Focused task was closed");
            }
          }
        `
      }
    }
  }
};
